module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-3-879fede60c81e9fefb340d1ca7d48f6e.webp";